export default __webpack_public_path__ + "static/media/Barlow-Bold.2dc03d2e.ttf";